import axios from 'axios'
import _ from 'lodash'

import {ApplicationPath} from "../class/ApplicationPath"
import {Oefening} from '../class/project'
import {DateUtil} from "../util/DateUtil";

const OEFENING_TABLE: string = 'oefening'
const OEFENING_LIJN_TABLE: string = 'oefening_lijn'

export class OefeningService {

    oefeningenLookup: object = {}
    oefeningLijnenLookup: object = {}

    constructor() {
    }

    getOefeningen = (project) => {
        return new Promise((resolve, reject) => {

            if (this.oefeningenLookup[project.id]){
                resolve(this.oefeningenLookup[project.id])
                return
            }
            //GET /records/posts?join=comments,users&join=tags

            const url = `${ApplicationPath.CRUD}${OEFENING_TABLE}/?transform=1&filter[]=project,eq,${project.id}&order=id,desc&token=${ApplicationPath.API_KEY}`
            axios.get(url)
                .then(response => {
                    this.oefeningenLookup[project.id] = response.data[OEFENING_TABLE]
                    resolve(this.oefeningenLookup[project.id])
                })
                .catch(error => {
                    console.error('GET OEFENING ERROR', error)
                    reject(error)
                })
        })
    }


    updateOefening = (oefening) => {

        //oefening.datum_wijziging = DateUtil.getNowMysql()

        const url = `${ApplicationPath.CRUD}${OEFENING_TABLE}/${oefening.id}?transform=1&token=${ApplicationPath.API_KEY}`

        return new Promise((resolve, reject) => {
                axios.put(url, oefening)
                    .then((result) => {
                        resolve(result)
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    }

    createOefening = (oefening) => {

        return new Promise((resolve, reject) => {
            let url = `${ApplicationPath.CRUD}${OEFENING_TABLE}/?transform=1&token=${ApplicationPath.API_KEY}`

            axios.post(url, oefening)
                .then((result) => {
                    oefening.id = result.data
                    oefening.datum_aanmaak = DateUtil.getNowMysql()
                    this.oefeningenLookup[oefening.project] = [oefening, ...this.oefeningenLookup[oefening.project]]

                    resolve({oefening, oefeningen: this.oefeningenLookup[oefening.project]})
                })
                .catch((error) => {
                    console.log(error)
                    reject(error)
                })
        })
    }

    deleteOefening = (oefening) => {

        return new Promise((resolve, reject) => {


            //TODO delete oefening lijnen

            const url = `${ApplicationPath.CRUD}oefening/${oefening.id}?transform=1&token=${ApplicationPath.API_KEY}`

            axios.delete(url)
                .then((result) => {
                    this.oefeningenLookup[oefening.project] = this.oefeningenLookup[oefening.project].filter(p => p['id'] !== oefening.id)

                    resolve({oefeningen: this.oefeningenLookup[oefening.project]})
                })
                .catch((error) => {
                    console.log(error)
                    reject(error)
                })
        })
    }

    //==============================================================
    //==============================================================
    //                      OEFENING LIJNEN
    //==============================================================
    //==============================================================

    getOefeningLijnen = (oefening) => {
        return new Promise((resolve, reject) => {

            if (this.oefeningLijnenLookup[oefening.id]){
                resolve(this.oefeningLijnenLookup[oefening.id])
                return
            }

            const url = `${ApplicationPath.CRUD}${OEFENING_LIJN_TABLE}/?transform=1&filter[]=oefening,eq,${oefening.id}&order=id,asc&token=${ApplicationPath.API_KEY}`
            axios.get(url)
                .then(response => {
                    this.oefeningLijnenLookup[oefening.id] = response.data[OEFENING_LIJN_TABLE]
                    resolve(this.oefeningLijnenLookup[oefening.id])
                })
                .catch(error => {
                    console.error('GET OEFENING LIJNEN ERROR', error)
                    reject(error)
                })
        })
    }


    updateOefeningLijn = (oefeningLijn) => {

        //oefening.datum_wijziging = DateUtil.getNowMysql()

        const url = `${ApplicationPath.CRUD}${OEFENING_LIJN_TABLE}/${oefeningLijn.id}?transform=1&token=${ApplicationPath.API_KEY}`

        return new Promise((resolve, reject) => {
                axios.put(url, oefeningLijn)
                    .then((result) => {
                        resolve(result)
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    }

    createOefeningLijn = (oefeningLijn) => {

        return new Promise((resolve, reject) => {
            let url = `${ApplicationPath.CRUD}${OEFENING_LIJN_TABLE}/?transform=1&token=${ApplicationPath.API_KEY}`

            axios.post(url, oefeningLijn)
                .then((result) => {
                    oefeningLijn.id = result.data

                    this.oefeningLijnenLookup[oefeningLijn.oefening] = [oefeningLijn, ...this.oefeningLijnenLookup[oefeningLijn.oefening]]

                    resolve({oefeningLijn, oefeningLijnen: this.oefeningLijnenLookup[oefeningLijn.oefening]})
                })
                .catch((error) => {
                    console.log(error)
                    reject(error)
                })
        })
    }

    deleteOefeningLijn = (oefeningLijn) => {

        return new Promise((resolve, reject) => {

            const url = `${ApplicationPath.CRUD}oefening_lijn/${oefeningLijn.id}?transform=1&token=${ApplicationPath.API_KEY}`

            axios.delete(url)
                .then((result) => {
                    this.oefeningLijnenLookup[oefeningLijn.oefening] = this.oefeningLijnenLookup[oefeningLijn.oefening].filter(p => p['id'] !== oefeningLijn.id)

                    resolve({oefeningLijnen: this.oefeningLijnenLookup[oefeningLijn.oefening]})
                })
                .catch((error) => {
                    console.log(error)
                    reject(error)
                })
        })
    }
}
